import React from 'react';

const AllBillers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
  >
    <g fill="#9B9B9B" fillRule="nonzero">
      <path d="M9.989 1.61L13.39 5.01c.07.07.11.166.11.265v10.849a.375.375 0 0 1-.375.375H1.875a.375.375 0 0 1-.375-.375V1.875c0-.207.168-.375.375-.375h7.849c.099 0 .194.04.264.11zm.2-1.61H1.5A1.5 1.5 0 0 0 0 1.5v15A1.5 1.5 0 0 0 1.5 18h12a1.5 1.5 0 0 0 1.5-1.5V4.81a.75.75 0 0 0-.22-.53L10.72.22a.75.75 0 0 0-.53-.22z" />
      <path d="M10.5 8.25H3.75a.75.75 0 0 1 0-1.5h6.75a.75.75 0 1 1 0 1.5zM10.5 11.25H3.75a.75.75 0 1 1 0-1.5h6.75a.75.75 0 1 1 0 1.5zM7.125 14.25H3.75a.75.75 0 1 1 0-1.5h3.375a.75.75 0 1 1 0 1.5z" />
    </g>
  </svg>
);

export default AllBillers;
